module.exports = __webpack_public_path__ + "static/media/active0drive.3642725a.jpg";